import { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';

import usePageLanguage from '../../hooks/usePageLanguage';
import BannerContainer from '../Banner/BannerContainer';
import CategoryList from './components/CategoryList';
import CustomBreadCrumbs from './components/CustomBreadCrumbs';
import SearchInput from '../SearchInput';
import { getSizesCategory } from '../../services/Sizes';
import { BANNER_IMAGE, INPUT_PLACEHOLDER } from './constants';
import { SizesType, LandingsType } from './types';
import TopBanner from './components/TopBanner';

import useStyles from './styles';

function Sizes({ title, description }: SizesType) {
  const styles = useStyles();
  const navigate = useNavigate();
  const { language } = usePageLanguage();
  const [sizesCategory, setSizesCategory] = useState<LandingsType[]>();
  const { page } = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    void (async () => {
      try {
        const result = (await getSizesCategory(language)) as LandingsType[];
        setSizesCategory(result);
      } catch (err) {
        console.error('Error fetching landings by Category', err);
      }
    })();
  }, [language]);

  useEffect(() => {
    if (searchParams.get('q') && searchParams.get('q').length > 0) {
      const categoryFont = sizesCategory?.find(
        item => item.slug.toLowerCase() === `sizes/${searchParams.get('q').toLowerCase()}`,
      );
      if (categoryFont) {
        navigate(`/${categoryFont.slug}/`);
      } else {
        console.error('Font not found');
      }
    }
  }, [sizesCategory, navigate, searchParams]);

  return (
    <div className={styles.root}>
      <BannerContainer className={styles.headerBg} backgroundImage={BANNER_IMAGE}>
        <HorizontalContainer>
          <CustomBreadCrumbs landings={sizesCategory} />
        </HorizontalContainer>
        <div className={styles.bannerContainer}>
          <TopBanner title={title} description={description} />
          <SearchInput placeholder={INPUT_PLACEHOLDER} containerClassName={styles.searchInput} />
          <CategoryList landings={sizesCategory} pagePath={page} />
        </div>
      </BannerContainer>
    </div>
  );
}

export default Sizes;
